import { PropsWithChildren, ReactNode } from 'react'
import { observer } from 'mobx-react'
import { ListItemIcon, ListItemText } from '@material-ui/core'
import {
  IAccountSettingsDrawerGroupItem
} from 'common/types/account-settings-drawer.types'
import { accountSettingsStoreState } from 'models/account-settings/account-settings.store'
import { StyledListItem } from './styled'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'

export interface IAdminDrawerCollapsableProps extends IAccountSettingsDrawerGroupItem {
  icon?: ReactNode
  onListItemClick?: Function
}

const AccountSettingsItem = ({ icon, groupName , onListItemClick}: PropsWithChildren<IAdminDrawerCollapsableProps>) => {
  const { selectItem, selectedItem } = accountSettingsStoreState
  const {isDevice} = useScreenSizes()

  return (
    <>
      <StyledListItem
        isDevice={isDevice}
        groupName={groupName}
        selectedItem={selectedItem}
        button
        onClick={() => {
          isDevice && onListItemClick()
          selectItem(groupName)
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={groupName}
          primaryTypographyProps={{
            variant: 'subtitle1'
          }}
        />
      </StyledListItem>
    </>
  )
}

export default observer(AccountSettingsItem)
